<template>
  <li class="file-list__item flex border-b border-gray-400 py-4">
    <div class="information flex w-4/5 mr-4">
      <label :for="fileInpId" v-if="notUploadFile" class="logo cursor-pointer">
        <md-icon class="md-size-2x hover:text-blue-400">cloud_upload</md-icon>
      </label>

      <label v-else class="logo cursor-pointer">
        <md-icon class="md-size-2x">insert_drive_file</md-icon>
      </label>

      <div class="content w-full ml-4">
        <label
          v-if="notUploadFile"
          :for="fileInpId"
          class="hover:text-blue-400 cursor-pointer"
        >
          {{ $t("certificate.click_here_to_upload_file") }}
        </label>

        <a
          :href="src"
          v-else
          class="file-name font-medium text-base cursor-pointer text-gray-700 duration-150 break-words"
          >{{ fileName }}
          <md-icon class="mt-[-4px] duration-150">cloud_download</md-icon></a
        >

        <div class="desc relative" v-click-outside="closeDescEdit">
          <input
            ref="descInp"
            class="font-normal"
            :value="desc"
            @input="updateDesc"
            placeholder="No description"
            :disabled="!descEdittable"
            @keyup="handleKeyup"
            maxlength="255"
          />

          <div class="desc-actions absolute" v-if="!descEdittable">
            <md-button
              class="md-simple md-just-icon md-icon-button md-success"
              @click.native.prevent="turnOnDescEdit"
            >
              <md-icon>edit</md-icon>
            </md-button>
          </div>

          <div class="desc-actions second absolute" v-else>
            <!-- <md-button
              class="md-simple md-just-icon md-icon-button  md-success"
              @click.native.prevent="closeDescEdit"
            >
              <md-icon>check</md-icon>
            </md-button> -->
            <md-button
              class="md-simple md-just-icon md-icon-button  md-danger"
              @click.native.prevent="closeDescEdit"
            >
              <md-icon>close</md-icon>
            </md-button>
          </div>
        </div>
      </div>
    </div>
    <div class="actions ml-auto">
      <md-button
        class="ml-2 md-simple md-just-icon md-icon-button md-danger"
        @click.native.prevent="deleteFile"
      >
        <md-icon :style="{ fontSize: '30px !important' }"
          >delete_forever</md-icon
        >
      </md-button>
    </div>
    <input type="file" :id="fileInpId" class="hidden" @change="uploadFile" />
  </li>
</template>

<script>
export default {
  props: ["idx", "src", "fileName", "desc", "type", "fileSrc"],
  data() {
    return {
      descEdittable: false
    };
  },
  computed: {
    fileInpId() {
      return `${this.src}-file-${this.idx}`;
    },

    notUploadFile() {
      return !this.src;
    }
  },
  methods: {
    toggleDescEdit() {
      this.descEdittable = !this.descEdittable;
    },
    turnOnDescEdit() {
      this.descEdittable = true;
      this.$nextTick(() => {
        this.$refs.descInp.focus();
      });
    },
    closeDescEdit() {
      this.descEdittable = false;
      this.$nextTick(() => {
        this.$refs.descInp.blur();
      });
    },
    deleteFile() {
      this.$emit("delete-file", this.idx);
    },
    uploadFile(event) {
      const file = event.target.files[0];
      this.$emit("update:src", window.URL.createObjectURL(file));
      this.$emit("update:fileName", file.name);
      this.$emit("update:fileSrc", file);
    },
    updateDesc(event) {
      this.$emit("update:desc", event.target.value);
    },
    handleKeyup(event) {
      if (event.keyCode === 13) {
        this.closeDescEdit();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  a.file-name {
    &:hover {
      color: #60a5fa !important;
      & > * {
        color: #60a5fa;
      }
    }
  }
  .desc {
    input {
      width: 90%;
      overflow: hidden;
      text-overflow: ellipsis;

      &:not(:disabled) {
        font-style: italic;
      }
    }

    .desc-actions {
      top: -50%;
      right: 4%;

      //   &.second {
      //     right: -2%;
      //   }

      button {
        margin: 0;
      }
    }
  }
}
</style>
